/*global messages */

function csrfSafeMethod(method) {
    // these HTTP methods do not require CSRF protection
    return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
}

function sameOrigin(url) {
    // test that a given url is a same-origin URL
    // url could be relative or scheme relative or absolute
    var host = document.location.host; // host + port
    var protocol = document.location.protocol;
    var sr_origin = '//' + host;
    var origin = protocol + sr_origin;
    // Allow absolute or scheme relative URLs to same origin
    return (url == origin || url.slice(0, origin.length + 1) == origin + '/') ||
        (url == sr_origin || url.slice(0, sr_origin.length + 1) == sr_origin + '/') ||
        // or any other URL that isn't scheme relative or absolute i.e relative.
        !(/^(\/\/|http:|https:).*/.test(url));
}

var csrftoken = $.cookie('csrftoken');

$.ajaxSetup({
    beforeSend: function (xhr, settings) {
        if (!csrfSafeMethod(settings.type) && sameOrigin(settings.url)) {
            // Send the token to same-origin, relative URLs only.
            // Send the token only if the method warrants CSRF protection
            // Using the CSRFToken value acquired earlier
            xhr.setRequestHeader("X-CSRFToken", csrftoken);
        }
    }
});

function update_genre_control() {
    if ($('div.catalog-genre-genres').css('display') === 'block') {
        $('span.show').css('background-position', 'right 6px');
        $('#genre_filter_control').text('Скрыть категории');
    } else {
        $('span.show').css('background-position', 'right -7px');
        $('#genre_filter_control').text('Показать категории');
    }
}

function initBookHOver(containerClass){
    $(containerClass).each(function(cIndex, cElement){

        var $container = $(cElement);

        $('.book-list--item', $container).each(function(index, element){
            var $book = $(element),
                bookAlign = '_al';

            if (containerClass == '.profile-book-list') {
                bookAlign = (index%4 == 2 || index%4 == 3) ? '_ar' : '_al';
            }
            else if (containerClass == '.book-list') {
                bookAlign = (index%5 == 3 || index%5 == 4) ? '_ar' : '_al';
            }

              $(element).on('mouseover', function(){
                  var desc = $('.bh--text', element);
                  var attr = desc.attr('data-desc');
                  var dec = Base64.decode(attr);
                  desc.html(dec);
              });

            addHoverToBook($book, bookAlign);
        });
    });
}

function addHoverToBook($book, bookAlign){
    var $bookHover = $('.book-hover', $book),
        hoverTimeout = false;

    $bookHover.addClass(bookAlign);

    $book.hover(function(){
        hoverTimeout = setTimeout(function(){
            if (!$bookHover.hasClass('_opened')) {
                $bookHover.addClass('_opened');
            }
        },300);
    }, function(){
        if ($bookHover.hasClass('_opened')) {
            $bookHover.removeClass('_opened');
        }
        clearTimeout(hoverTimeout);
    });
}

$(document).ready(function () {
    update_genre_control();
    $('a#genre_filter_control').click(function(){
         $('div.catalog-genre-genres').slideToggle(update_genre_control);
    });

    $('.nojs-content').hide();

    $('a.three-dots-open').click(function () {
        var $this = $(this),
            $sibling = $this.next();

        if ($sibling.hasClass('invisible-content')) {
            $sibling.removeClass('invisible-content');
            $this.remove();
        }
        return false;
    });

    $('.flexslider').flexslider({
        selector: ".review--slider > .review--item",
        animation: "slide",
        animationLoop: false,
        itemWidth: 313,
        itemMargin: 20,
        slideshow: false,
        move: 1
    });

    $('.select-box').not('.react-select-box').each(function(index, element){
        var $elem = $(element),
            $current = $('.select-box--current', $elem),
            $dropbox = $('.dropdown-box', $elem);

        $current.on('click', function(){
            if (!$elem.hasClass('_opened')) {
                $('.select-box').not('.react-select-box').removeClass('_opened');
                $elem.addClass('_opened');
            } else {
                $elem.removeClass('_opened');
            }
        });

        $(document).on('click.dropoff', function(e){
            var $obj = $(e.target);
            var is_clickOnselect = $obj.parents('.select-box').not('.react-select-box').size();

            if (!is_clickOnselect) {
                $('.select-box').not('.react-select-box').removeClass('_opened');
            }
        });
    });
});
